import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import TaxActions, { taxActionTypes } from '@Actions/taxActions';
import TaxServices from '@Services/taxServices';

/**
 *
 * @param {*} action
 */
function* _createTax(action) {
  try {
    yield put(TaxActions.createTaxLoading(true));
    const { payload } = action;
    const newGst = yield TaxServices.createTax(payload);
    if (newGst.success) {
      yield put(TrackerActions.trackAction(taxActionTypes.CREATE_TAX.SUCCESS, {
        request: action?.payload,
        response: newGst,
      }));
      notification.open({
        type: 'success',
        message: 'TAX created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: newGst.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TaxActions.createTaxLoading(false));
  } catch (error) {
    yield put(TaxActions.createTaxLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(taxActionTypes.CREATE_TAX.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createTax() {
  yield takeLatest(taxActionTypes.CREATE_TAX.REQUEST, _createTax);
}

/**
 *
 * @param {*} action
 */
function* _getTaxes(action) {
  try {
    yield put(TaxActions.getTaxesLoading(true));

    const Gsts = yield TaxServices.getTaxes(action?.orgId, action?.page, action?.limit, action?.isActive, action?.isTaxGroup === false ? 'false' : action?.isTaxGroup, action?.isDocLevel === false ? 'false' : action?.isDocLevel);
    yield put(TaxActions.getTaxesSuccess(Gsts, action?.isTaxGroup));
    yield put(TaxActions.getTaxesLoading(false));
    if (action.callback) {
      action.callback(Gsts);
    }
  } catch (error) {
    yield put(TaxActions.getTaxesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(taxActionTypes.GET_TAXES.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getTaxes() {
  yield takeLatest(taxActionTypes.GET_TAXES.REQUEST, _getTaxes);
}

/**
 *
 * @param {*} action
 */
function* _updateTax(action) {
  try {
    yield put(TaxActions.updateTaxLoading(true));
    const updatedGst = yield TaxServices.updateTax(action.payload);
    if (updatedGst.success) {
      yield put(TrackerActions.trackAction(taxActionTypes.UPDATE_TAX.SUCCESS, {
        request: action?.payload,
        response: updatedGst,
      }));
      notification.open({
        type: 'success',
        message: 'TAX updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatedGst.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TaxActions.updateTaxLoading(false));
  } catch (error) {
    yield put(TaxActions.updateTaxLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(taxActionTypes.UPDATE_TAX.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* updateTax() {
  yield takeLatest(taxActionTypes.UPDATE_TAX.REQUEST, _updateTax);
}

/**
 *
 * @param {*} action
 */
function* _getTaxTypes(action) {
  try {
    yield put(TaxActions.getTaxTypesLoading(true));
    const taxTypes = yield TaxServices.getTaxTypes(action?.orgId, action?.page, action?.limit, action?.isActive);
    yield put(TaxActions.getTaxTypesSuccess(taxTypes));
    yield put(TaxActions.getTaxTypesLoading(false));
  } catch (error) {
    yield put(TaxActions.getTaxTypesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(taxActionTypes.GET_TAX_TYPES.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getTaxTypes() {
  yield takeLatest(taxActionTypes.GET_TAX_TYPES.REQUEST, _getTaxTypes);
}

/**
 *
 */
export default function* taxSaga() {
  yield all([createTax(), getTaxes(), updateTax(), getTaxTypes()]);
}
